import React from 'react';
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

type TrailerExpandedItemsProps = {
  trailer: any;
  onAddRow: (id: string) => void;
  onDeleteRow: (id: string, index: number) => void;
  onProductChange: (
    value: string,
    id: string,
    index: number,
    column: string
  ) => void;
  onDeleteTrailer: (trailerNo: string) => void;
};

const TrailerExpandedItems: React.FC<TrailerExpandedItemsProps> = ({
  trailer,
  onAddRow,
  onDeleteRow,
  onProductChange,
  onDeleteTrailer,
}) => {
  return (
    <Box sx={{ p: 2, bgcolor: '#fafafa' }}>
      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <Table size="small" sx={{ width: '100%'}}>
          <TableHead>
            <TableRow>
              <TableCell width={60}>
                <IconButton size="small" onClick={() => onAddRow(trailer.id)}>
                  <AddIcon fontSize="small" />
                </IconButton>
              </TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Description</TableCell>
              <TableCell width={140}>Skids</TableCell>
              <TableCell width={60}>Delete</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {trailer?.products?.map((prod: any, index: number) => (
              <TableRow key={`skid-${trailer.id}-${index}`}>
                <TableCell />
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    value={prod?.label || ''}
                    onChange={(e) =>
                      onProductChange(e.target.value, trailer.id, index, 'label')
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    value={prod?.description || ''}
                    onChange={(e) =>
                      onProductChange(e.target.value, trailer.id, index, 'description')
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    type="number"
                    value={prod?.skid ?? 0}
                    onChange={(e) =>
                      onProductChange(e.target.value, trailer.id, index, 'skid')
                    }
                  />
                </TableCell>

                <TableCell>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => onDeleteRow(trailer.id, index)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {/* <TableRow>
              <TableCell colSpan={4} />
              <TableCell>
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => onDeleteTrailer(trailer.trailer_no)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow> */}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default TrailerExpandedItems;